import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import Aiimage from '../images/services/ai-solutions.jpg';
import api from '../images/services/api-development.jpg';
import software from '../images/services/custom-software.jpg';
import vr from '../images/services/virtual-reality.jpg';
import blockchain from '../images/services/blockchain-solutions.jpg';

export default function Services() {
  const { t } = useTranslation();

  const serviceItems = [
    { id: 'ai', img: Aiimage, title: t('service_ai_title'), desc: t('service_ai_description'), alt: t('service_ai_alt') || 'AI Solutions', reverse: false },
    { id: 'api', img: api, title: t('service_api_title'), desc: t('service_api_description'), alt: t('service_api_alt') || 'API Development', reverse: true },
    { id: 'software', img: software, title: t('service_software_title'), desc: t('service_software_description'), alt: t('service_software_alt') || 'Custom Software', reverse: false },
    { id: 'vr', img: vr, title: t('service_vr_title'), desc: t('service_vr_description'), alt: t('service_vr_alt') || 'Virtual Reality', reverse: true },
    { id: 'blockchain', img: blockchain, title: t('service_blockchain_title'), desc: t('service_blockchain_description'), alt: t('service_blockchain_alt') || 'Blockchain Solutions', reverse: false },
  ];

  return (
    <section id="servicios" className="py-16 bg-gray-100">
      <div className="container mx-auto px-4 sm:px-6 md:px-8">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12 text-gray-800">
          {t('services_title')}
        </h2>

        {serviceItems.map(({ id, img, title, desc, alt, reverse }) => (
          <div
            key={id}
            className={`flex flex-col md:flex-row items-center mb-12 ${reverse ? 'md:flex-row-reverse' : ''}`}
          >
            <div className="w-full md:w-1/2">
              <img
                src={img}
                alt={alt}
                loading="lazy"
                className="w-full h-auto rounded-lg shadow-lg service-image"
              />
            </div>
            <div className="w-full md:w-1/2 md:px-8 mt-6 md:mt-0">
              <h3 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-4">
                {title}
              </h3>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                {desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
